import React, { useCallback, useEffect, useState } from "react";
import { Header } from "../components/site/Header";
import { Hero } from "../components/site/Hero";
import { ProblemSection, SolutionSection, FeaturesOverview, BenefitsSection, DifferentiationSection } from "../components/site/NarrativeSections";
import { TenderFeature, PartnerFeature, WorkspaceFeature } from "../components/site/Features";
import { TargetAudience } from "../components/site/TargetAudience";
import { EarlyAccess } from "../components/site/EarlyAccess";
import { Footer } from "../components/site/Footer";
import { getWaitlistCount } from "../lib/api";

export default function Landing() {
  const [count, setCount] = useState(0);
  const refreshCount = useCallback(async () => {
    try {
      setCount(await getWaitlistCount());
    } catch (error) {
      // Non-critical: the waitlist counter is a nice-to-have. Log only outside production.
      if (process.env.NODE_ENV !== "production") {
        console.error("Waitlist count unavailable:", error);
      }
    }
  }, [getWaitlistCount, setCount]);
  useEffect(() => { refreshCount(); }, [refreshCount]);
  return (
    <div className="min-h-screen bg-[var(--bg)]">
      <Header />
      <main>
        <Hero waitlistCount={count} />
        <ProblemSection />
        <SolutionSection />
        <FeaturesOverview />
        <TenderFeature />
        <PartnerFeature />
        <WorkspaceFeature />
        <BenefitsSection />
        <DifferentiationSection />
        <TargetAudience />
        <EarlyAccess onSuccess={refreshCount} />
      </main>
      <Footer />
    </div>
  );
}
